import React from "react";
import { ShieldCheck } from "lucide-react";
import { WARRANTY_TABLE } from "../lib/vehicles";

export const WarrantyTable = ({ className = "" }) => {
  return (
    <div
      data-testid="warranty-table"
      className={`bg-[#0a0a0a] border border-white/10 rounded-2xl overflow-hidden ${className}`}
    >
      <div className="px-6 py-4 border-b border-white/5 flex items-center gap-2.5">
        <ShieldCheck
          className="w-4 h-4"
          style={{ color: "#39FF14" }}
          strokeWidth={1.8}
        />
        <h3 className="text-sm font-medium text-white">
          EV Battery Warranty by Model · Tesla & Ford · US 2026
        </h3>
        <span className="ml-auto font-mono text-[10px] uppercase tracking-wider text-zinc-500 hidden sm:inline">
          Source · tesla.com · ford.com
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="text-[10px] uppercase tracking-wider text-zinc-500 font-mono border-b border-white/5">
              <th className="text-left font-normal py-3 px-5">Model</th>
              <th className="text-left font-normal py-3 px-5">Trims</th>
              <th className="text-right font-normal py-3 px-5">Years</th>
              <th className="text-right font-normal py-3 px-5">Miles</th>
              <th className="text-right font-normal py-3 px-5 pr-6">
                70% retention
              </th>
            </tr>
          </thead>
          <tbody>
            {WARRANTY_TABLE.map((row, i) => (
              <tr
                key={`${row.model}-${i}`}
                className="border-b border-white/5 last:border-b-0 hover:bg-white/[0.02]"
                data-testid={`warranty-row-${row.model.toLowerCase().replace(/\s+/g, "-")}-${i}`}
              >
                <td className="py-3 px-5 text-sm text-white font-medium">
                  {row.model}
                </td>
                <td className="py-3 px-5 text-xs text-zinc-400">
                  {row.trims}
                </td>
                <td className="py-3 px-5 text-right font-mono text-sm text-white">
                  {row.years} yrs
                </td>
                <td className="py-3 px-5 text-right font-mono text-sm text-white">
                  {row.miles.toLocaleString()} mi
                </td>
                <td className="py-3 px-5 pr-6 text-right">
                  {row.threshold ? (
                    <span
                      className="inline-flex items-center gap-1.5 font-mono text-xs px-2 py-0.5 rounded-full border"
                      style={{
                        color: row.estimated ? "#FFB020" : "#39FF14",
                        borderColor: row.estimated
                          ? "rgba(255,176,32,0.3)"
                          : "rgba(57,255,20,0.3)",
                        background: row.estimated
                          ? "rgba(255,176,32,0.06)"
                          : "rgba(57,255,20,0.06)",
                      }}
                    >
                      {row.threshold}% {row.estimated ? "(est.)" : "guaranteed"}
                    </span>
                  ) : (
                    <span className="font-mono text-xs text-zinc-500">
                      Not published
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-6 py-3 border-t border-white/5 text-[11px] font-mono text-zinc-500 leading-relaxed">
        Warranty ends at whichever comes first — time or mileage. Next-gen
        Roadster terms are estimated based on Tesla's other halo trims;
        final published warranty will be confirmed at delivery.
      </div>
    </div>
  );
};
